import styled from 'styled-components';

export const Container = styled('div')<{ backgroundColor?: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor || '#ffffff'};
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: fit-content;
  margin: auto;
  width: 100px;
  border-radius: 4px;
`;
export const Header = styled('div')<{ backgroundColor?: string }>`
  display: flex;
  font-size: 8px;
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
  padding: 3px;
  box-sizing: border-box;
`;
export const HeaderTitle = styled('div')<{ textColor?: string }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 8px;
  color: ${({ textColor }) => textColor || '#ffffff'};
`;
export const HeaderRightContainer = styled('div')<{ backgroundColor?: string }>`
  display: flex;
  flex-direction: column;
  align-self: 'self-start';
  font-size: 4px;
  max-width: 10%;
`;
export const MidContainer = styled('div')<{ backgroundColor?: string }>`
  display: flex;
  font-size: 6px;
  justify-content: space-between;
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
`;
